import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

import { adobeLinkTrackEvent } from '../../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { adobeModalTrackEvent } from '../../../../../common/AdobeTagging/adobeModalTrackEvent';
import { handleLinkAndModalTrack } from '../../../../../common/Utils/adobeTrackUtils';

type Props = {
  onClick: (a: boolean) => void;
  icon: String;
  view: String;
  locationForAnalytics?: String;
  ariaLabel?: String;
  showMergedCompareAndShare?: boolean;
};

const DrawerMenuButtonStyled = styled(Button, {
  variants: {
    view: {
      mobile: {
        '&.abyss-button-root': {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
    },
  },
});

const handleMoreActionsModalLinkTrack = (
  locationForAnalytics,
  icon,
  showMergedCompareAndShare
) => {
  if (showMergedCompareAndShare) {
    adobeLinkTrackEvent({
      name: 'Close',
      location: 'Compare providers overlay',
      type: 'Internal',
    });
    adobeModalTrackEvent('are you sure you want to exit');
  } else {
    const linkName: string = 'more actions';
    const modalName: string =
      icon === 'close' ? 'close confirmation' : 'more actions';
    const location: string = locationForAnalytics;
    handleLinkAndModalTrack(linkName, location, modalName);
  }
};

export const DrawerMenuButton = ({
  onClick,
  icon,
  view,
  locationForAnalytics,
  ariaLabel,
  showMergedCompareAndShare,
}: Props) => (
  <DrawerMenuButtonStyled
    aria-label={ariaLabel}
    data-auto-testid="mapview-compare-drawer-menu"
    data-testid="mapview-compare-drawer-menu"
    onClick={() => {
      handleMoreActionsModalLinkTrack(
        locationForAnalytics,
        icon,
        showMergedCompareAndShare
      );
      onClick(true);
    }}
    variant="text"
    view={view}
  >
    <IconSymbol
      data-auto-testid={`compare-drawer-close-${icon}`}
      data-testid={`compare-drawer-close-${icon}`}
      icon={icon}
      size="$md"
    />
  </DrawerMenuButtonStyled>
);
